import styled from 'styled-components';

const Custom404TemplateStyle = styled.section`
	--distanceTitle: var(--sp11x);
	--distanceDesc: var(--sp4x);
	--distanceBtn: var(--sp11x);

	height: calc(100vh - var(--headerFixedHeight));
	position: relative;

	.error-container {
		position: absolute;
		top: 50%;
		left: 50%;
		transform: translate(-50%, -50%);
	}

	.main-wrapper {
		display: flex;
		flex-direction: column;
		align-items: center;
	}

	.title {
		margin: var(--distanceTitle) 0 var(--distanceDesc);
	}

	.btn {
		margin-top: var(--distanceBtn);
	}

	//! 1920
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeXLMin}) and (min-width: ${(props) => props.theme.mediaQuery.desktopSizeL}) {
		--distanceTitle: var(--sp7x);
		--distanceDesc: var(--sp3x);
		--distanceBtn: var(--sp7x);
	}

	//! 1536
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeLMin}) and (min-width: ${(props) => props.theme.mediaQuery.desktopSizeM}) {
		--distanceTitle: var(--sp5x);
		--distanceDesc: var(--sp2x);
		--distanceBtn: var(--sp5x);
	}

	//! 1366
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeMMin}) and (min-width: ${(props) => props.theme.mediaQuery.desktopSizeS}) {
		--distanceDesc: var(--sp3x);
	}

	//! 1280
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeSMin}) and (min-width: ${(props) => props.theme.mediaQuery.tabletSize}) {
		--distanceBtn: var(--sp4x);
	}

	//! 1024 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.tabletSizeMin}) {
		--distanceTitle: var(--sp4x);
		--distanceDesc: var(--sp1-5x);
		--distanceBtn: var(--sp2-5x);
	}

	//! 768
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.tabletSizeXMin}) and (min-width: ${(props) => props.theme.mediaQuery.tabletSizeS}) {
		--distanceTitle: var(--sp3x);
		--distanceBtn: var(--sp3x);
	}

	//! Mobile
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.tabletSizeSMin}) {
		--distanceDesc: var(--sp2x);
	}
`;

export default Custom404TemplateStyle;
